var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3dafe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: 377.502,
    x2: 260.492,
    y1: 132.502,
    y2: 249.511,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 413.343,
    x2: 413.343,
    y1: 253,
    y2: 142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bacdf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: 293.501,
    x2: 191.996,
    y1: 216.501,
    y2: 318.006,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "g",
    x1: 211.585,
    x2: 148.585,
    y1: 295.922,
    y2: 361.922,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "h",
    x1: 154.5,
    x2: 105.246,
    y1: 355.5,
    y2: 404.754,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#f3035f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#d70252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "i",
    x1: 60,
    x2: 60,
    y1: 398,
    y2: 506.06,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "j",
    x1: 343,
    x2: 458.039,
    y1: 31,
    y2: 146.039,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca2e43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#be2c40",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#a22639",
    stopOpacity: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972437"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "k",
    x1: 411,
    x2: 411,
    y1: 119,
    y2: 196.007,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "l",
    x1: 468.525,
    x2: 422.193,
    y1: 156.475,
    y2: 110.143,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "m",
    x1: 377.026,
    x2: 431.694,
    y1: 64.974,
    y2: 119.643,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M472.474 483.671c-20.033 0-36.652-15.834-37.445-36.029C427.13 246.566 263.434 82.869 62.358 74.971c-20.695-.813-36.812-18.248-36-38.943.813-20.695 18.262-36.805 38.943-36 116.706 4.584 226.54 52.67 309.27 135.399 82.729 82.73 130.815 192.564 135.399 309.27.812 20.694-15.305 38.13-36 38.943-.499.021-1 .031-1.496.031z",
    opacity: 1,
    "data-original": "url(#d)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M485.689 313.696c-22.628-66.513-60.346-127.495-111.118-178.268l-33.575 33.575z",
    opacity: 1,
    "data-original": "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M358.431 478.671c-17.152 0-31.495-13.428-32.425-30.76-7.66-142.797-121.12-256.257-263.917-263.917-17.924-.961-31.674-16.271-30.712-34.194.961-17.923 16.281-31.673 34.194-30.712 84.836 4.55 164.715 40.214 224.921 100.421s95.871 140.085 100.421 224.921c.962 17.923-12.789 33.232-30.712 34.194a33.96 33.96 0 0 1-1.77.047z",
    opacity: 1,
    "data-original": "url(#f)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M254.555 468.671c-11.607 0-21.453-8.921-22.402-20.692-7.356-91.224-78.907-162.775-170.131-170.131-12.386-.999-21.617-11.85-20.619-24.236.999-12.386 11.854-21.611 24.236-20.619 54.438 4.39 105.753 28.141 144.49 66.878s62.488 90.052 66.878 144.49c.999 12.386-8.232 23.237-20.619 24.236-.615.05-1.227.074-1.833.074z",
    opacity: 1,
    "data-original": "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M170.954 458.671c-6.158 0-11.521-4.55-12.371-10.822-6.78-49.998-46.435-89.653-96.433-96.433-6.841-.928-11.635-7.226-10.707-14.066.928-6.841 7.225-11.632 14.066-10.707 61.101 8.286 109.561 56.747 117.847 117.847.928 6.841-3.866 13.139-10.707 14.066-.569.078-1.136.115-1.695.115z",
    opacity: 1,
    "data-original": "url(#h)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 450,
    r: 60,
    fill: "url(#i)",
    opacity: 1,
    "data-original": "url(#i)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411,
    cy: 99,
    r: 99,
    fill: "url(#j)",
    opacity: 1,
    "data-original": "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M340.996 169.004c38.662 38.662 101.345 38.662 140.007 0 25.746-25.746 34.323-62.14 25.779-95.004H315.218c-8.545 32.864.032 69.257 25.778 95.004z",
    opacity: 1,
    "data-original": "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m509.423 88.48-43.762-43.762-108.893 108.894 43.825 43.825c28.682 3.014 58.428-6.451 80.41-28.433 22.012-22.011 31.472-51.806 28.42-80.524z",
    opacity: 1,
    "data-original": "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m465.394 135.77-36.717-36.72 36.526-36.526c4.867-4.867 5.235-12.85.458-17.805-4.865-5.048-12.9-5.104-17.845-.168L411 81.37l-36.817-36.82c-4.945-4.936-12.98-4.88-17.845.168-4.776 4.956-4.409 12.938.458 17.805l36.526 36.526-36.717 36.72c-4.882 4.882-4.882 12.798 0 17.68 2.44 2.44 5.64 3.66 8.84 3.66s6.39-1.22 8.83-3.66L411 116.727l36.723 36.723c2.44 2.44 5.63 3.66 8.83 3.66s6.4-1.22 8.84-3.66c4.883-4.882 4.883-12.798.001-17.68z",
    opacity: 1,
    "data-original": "url(#m)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.4b7ee24deae29d23af544950f6122331.svg";
export { ForwardRef as ReactComponent };